module.exports = __webpack_public_path__ + "media/components/partials/LandingComponents/General/Footer/img/instagram-0b585d526d61cbc6b1efce28278c594a.svg";